import React from "react";
import NewPassword from "../components/auth/NewPassword";

export default function NewPasswordPage() {
  return <NewPassword />;
}
